
import { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

interface GalleryImage {
  id: number;
  src: string;
  alt: string;
  title: string;
  category: string;
}

const galleryImages: GalleryImage[] = [
  {
    id: 1,
    src: 'https://public.readdy.ai/ai/img_res/30cfd0957b224ecc317a8199619b78d5.jpg',
    alt: 'Mercedes Classe E devant chalet alpin - Berline premium Voyage Elite',
    title: 'Mercedes Classe E - Berline Premium',
    category: 'vehicules',
  },
  {
    id: 2,
    src: 'https://readdy.ai/api/search-image?query=Black%20Mercedes%20V-Class%20luxury%20van%20on%20a%20snowy%20mountain%20road%20in%20the%20French%20Alps%2C%20dramatic%20winter%20landscape%20with%20pine%20trees%20covered%20in%20snow%2C%20professional%20automotive%20photography%2C%20side%20angle%20showing%20spacious%20design%2C%20warm%20golden%20hour%20light%2C%20premium%20transport%20vehicle%20for%20ski%20resort%20transfers%2C%20clean%20and%20elegant%20composition&width=800&height=600&seq=gal02fleet&orientation=landscape',
    alt: 'Mercedes Classe V sur route enneigée - Van premium transfert ski',
    title: 'Mercedes Classe V - Van Premium',
    category: 'vehicules',
  },
  {
    id: 3,
    src: 'https://readdy.ai/api/search-image?query=Luxurious%20black%20Mercedes%20S-Class%20sedan%20front%20three%20quarter%20view%20in%20an%20upscale%20mountain%20resort%20setting%2C%20polished%20chrome%20details%20gleaming%2C%20LED%20headlights%20illuminated%2C%20elegant%20stone%20building%20entrance%20in%20background%2C%20valet%20service%20atmosphere%2C%20professional%20automotive%20photography%2C%20warm%20evening%20lighting%2C%20ultra%20premium%20luxury%20transport&width=800&height=600&seq=gal03fleet&orientation=landscape',
    alt: 'Mercedes Classe S - Luxe absolu chauffeur privé Alpes',
    title: 'Mercedes Classe S - Luxe Absolu',
    category: 'vehicules',
  },
  {
    id: 4,
    src: 'https://readdy.ai/api/search-image?query=Interior%20of%20a%20luxury%20Mercedes%20sedan%20showing%20premium%20beige%20leather%20seats%2C%20ambient%20lighting%20in%20warm%20tones%2C%20wooden%20trim%20details%2C%20rear%20passenger%20view%20with%20legroom%20visible%2C%20champagne%20glass%20holder%2C%20professional%20interior%20automotive%20photography%2C%20clean%20and%20elegant%2C%20soft%20focus%20on%20details%2C%20premium%20comfort%20atmosphere&width=800&height=600&seq=gal04interior&orientation=landscape',
    alt: 'Intérieur cuir premium Mercedes - Confort passager VTC Alpes',
    title: 'Intérieur Cuir Premium',
    category: 'services',
  },
  {
    id: 5,
    src: 'https://readdy.ai/api/search-image?query=Champagne%20bottle%20and%20two%20crystal%20glasses%20on%20a%20silver%20tray%20inside%20a%20luxury%20car%20rear%20seat%2C%20soft%20ambient%20LED%20lighting%2C%20premium%20leather%20interior%20visible%2C%20elegant%20presentation%20with%20small%20appetizer%20plate%2C%20professional%20still%20life%20photography%2C%20warm%20tones%2C%20bokeh%20background%20showing%20car%20window%20with%20mountain%20view%2C%20VIP%20chauffeur%20service%20amenities&width=800&height=600&seq=gal05service&orientation=landscape',
    alt: 'Service champagne à bord - Apéritifs VIP chauffeur privé',
    title: 'Apéritifs & Champagne à Bord',
    category: 'services',
  },
  {
    id: 6,
    src: 'https://readdy.ai/api/search-image?query=Professional%20chauffeur%20in%20elegant%20dark%20suit%20and%20white%20gloves%20opening%20the%20rear%20door%20of%20a%20black%20Mercedes%20luxury%20sedan%2C%20upscale%20hotel%20entrance%20with%20warm%20lighting%20in%20background%2C%20polished%20shoes%2C%20impeccable%20grooming%20professional%20portrait%20photography%20warm%20evening%20tones%20premium%20VTC%20service%20atmosphere%20French%20Alps%20luxury%20resort%20setting&width=800&height=600&seq=gal06chauffeur&orientation=landscape',
    alt: 'Chauffeur professionnel ouvrant la porte - Service VTC premium',
    title: 'Service Chauffeur Professionnel',
    category: 'services',
  },
  {
    id: 7,
    src: 'https://readdy.ai/api/search-image?query=Breathtaking%20panoramic%20view%20of%20Courchevel%20ski%20resort%20at%20sunset%20from%20an%20elevated%20mountain%20road%2C%20snow%20covered%20chalets%20and%20ski%20slopes%20visible%2C%20warm%20golden%20light%20on%20snow%20peaks%20dramatic%20sky%20with%20orange%20and%20pink%20clouds%20French%20Alps%20winter%20landscape%20wide%20angle%20cinematic%20photography%20luxury%20travel%20destination%20atmosphere&width=800&height=600&seq=gal07courchevel&orientation=landscape',
    alt: 'Vue panoramique Courchevel au coucher du soleil - Destination ski premium',
    title: 'Courchevel - Station de Prestige',
    category: 'destinations',
  },
  {
    id: 8,
    src: 'https://readdy.ai/api/search-image?query=Scenic%20winding%20mountain%20road%20through%20the%20French%20Alps%20in%20winter%2C%20black%20luxury%20sedan%20visible%20in%20the%20distance%2C%20snow%20covered%20pine%20forests%20on%20both%20sides%2C%20dramatic%20mountain%20peaks%20with%20clouds%2C%20golden%20hour%20sunlight%20creating%20long%20shadows%20cinematic%20landscape%20photography%20premium%20travel%20route%20atmosphere%20Val%20Thorens%20direction&width=800&height=600&seq=gal08route&orientation=landscape',
    alt: 'Route alpine vers Val Thorens - Transfert privé montagne',
    title: 'Route Alpine vers Val Thorens',
    category: 'destinations',
  },
  {
    id: 9,
    src: 'https://readdy.ai/api/search-image?query=Meribel%20ski%20village%20at%20twilight%20with%20warm%20lights%20from%20chalets%2C%20snow%20covered%20rooftops%20and%20streets%2C%20traditional%20Savoyard%20wooden%20architecture%2C%20mountain%20peaks%20in%20background%2C%20cozy%20winter%20atmosphere%20professional%20landscape%20photography%20warm%20amber%20tones%20from%20street%20lamps%20contrasting%20with%20blue%20twilight%20sky%20French%20Alps%20winter%20charm&width=800&height=600&seq=gal09meribel&orientation=landscape',
    alt: 'Village de Méribel au crépuscule - Architecture savoyarde stations ski',
    title: 'Méribel - Charme Savoyard',
    category: 'destinations',
  },
  {
    id: 10,
    src: 'https://readdy.ai/api/search-image?query=Luxury%20black%20Mercedes%20sedan%20arriving%20at%20Geneva%20International%20Airport%20terminal%2C%20modern%20glass%20architecture%20of%20airport%20visible%2C%20professional%20chauffeur%20standing%20by%20the%20car%2C%20luggage%20cart%20nearby%2C%20clean%20and%20organized%20airport%20pickup%20area%20warm%20daylight%20professional%20automotive%20and%20travel%20photography%20premium%20airport%20transfer%20service%20atmosphere&width=800&height=600&seq=gal10airport&orientation=landscape',
    alt: 'Transfert aéroport Genève - Mercedes premium accueil VIP',
    title: 'Transfert Aéroport Genève',
    category: 'destinations',
  },
  {
    id: 11,
    src: 'https://readdy.ai/api/search-image?query=Close%20up%20of%20luxury%20car%20amenities%20tray%20showing%20bottled%20water%2C%20warm%20blanket%20neatly%20folded%2C%20phone%20charging%20cables%2C%20WiFi%20hotspot%20device%2C%20and%20fresh%20mints%2C%20all%20arranged%20on%20premium%20leather%20surface%2C%20soft%20ambient%20car%20interior%20lighting%2C%20professional%20product%20photography%20warm%20tones%20premium%20VTC%20service%20details%20attention%20to%20comfort&width=800&height=600&seq=gal11amenities&orientation=landscape',
    alt: 'Équipements à bord - Wifi chargeurs eau couverture VTC premium',
    title: 'Confort & Équipements à Bord',
    category: 'services',
  },
  {
    id: 12,
    src: 'https://readdy.ai/api/search-image?query=Stunning%20aerial%20view%20of%20Chamonix%20Mont%20Blanc%20valley%20in%20winter%2C%20snow%20covered%20peaks%20and%20glaciers%2C%20the%20town%20visible%20below%20with%20warm%20lights%20dramatic%20mountain%20landscape%20at%20golden%20hour%20professional%20drone%20landscape%20photography%20breathtaking%20French%20Alps%20scenery%20luxury%20travel%20destination%20wide%20panoramic%20composition&width=800&height=600&seq=gal12chamonix&orientation=landscape',
    alt: 'Vue aérienne Chamonix Mont-Blanc - Destination premium Alpes',
    title: 'Chamonix Mont-Blanc',
    category: 'destinations',
  },
];

const categories = [
  { key: 'all', label: 'Toutes', icon: 'ri-gallery-line' },
  { key: 'vehicules', label: 'Véhicules', icon: 'ri-car-line' },
  { key: 'services', label: 'Services', icon: 'ri-service-line' },
  { key: 'destinations', label: 'Destinations', icon: 'ri-map-pin-line' },
];

export default function GalleryGrid() {
  const [activeCategory, setActiveCategory] = useState('all');
  const [selectedImage, setSelectedImage] = useState<GalleryImage | null>(null);

  const filteredImages = activeCategory === 'all'
    ? galleryImages
    : galleryImages.filter((img) => img.category === activeCategory);

  return (
    <section className="py-16 sm:py-20 lg:py-24 px-4 sm:px-6 lg:px-12 bg-white">
      <div className="max-w-7xl mx-auto">
        {/* Filters */}
        <div className="flex flex-wrap justify-center gap-3 mb-12">
          {categories.map((cat) => (
            <button
              key={cat.key}
              onClick={() => setActiveCategory(cat.key)}
              className={`inline-flex items-center gap-2 px-5 py-2.5 rounded-full font-inter text-sm font-medium transition-all cursor-pointer whitespace-nowrap ${
                activeCategory === cat.key
                  ? 'bg-voyage-gold text-night-blue shadow-lg'
                  : 'bg-slate-100 text-slate-600 hover:bg-slate-200'
              }`}
            >
              <i className={`${cat.icon} text-base`}></i>
              {cat.label}
            </button>
          ))}
        </div>

        {/* Grid */}
        <motion.div layout className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          <AnimatePresence mode="popLayout">
            {filteredImages.map((image) => (
              <motion.div
                key={image.id}
                layout
                initial={{ opacity: 0, scale: 0.9 }}
                animate={{ opacity: 1, scale: 1 }}
                exit={{ opacity: 0, scale: 0.9 }}
                transition={{ duration: 0.35 }}
                whileHover={{ y: -6 }}
                onClick={() => setSelectedImage(image)}
                className="group relative rounded-2xl overflow-hidden cursor-pointer shadow-md hover:shadow-2xl transition-shadow"
              >
                <div className="w-full h-64 sm:h-72 lg:h-80">
                  <img
                    src={image.src}
                    alt={image.alt}
                    title={image.title}
                    className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                    loading="lazy"
                  />
                </div>
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <div className="absolute bottom-0 left-0 right-0 p-5">
                    <p className="text-white font-inter text-sm font-semibold">{image.title}</p>
                    <span className="inline-block mt-1.5 text-voyage-gold font-inter text-xs uppercase tracking-wider">
                      {categories.find((c) => c.key === image.category)?.label}
                    </span>
                  </div>
                </div>
                <div className="absolute top-4 right-4 w-9 h-9 flex items-center justify-center bg-white/20 backdrop-blur-sm rounded-full opacity-0 group-hover:opacity-100 transition-opacity">
                  <i className="ri-zoom-in-line text-white text-lg"></i>
                </div>
              </motion.div>
            ))}
          </AnimatePresence>
        </motion.div>
      </div>

      {/* Lightbox */}
      <AnimatePresence>
        {selectedImage && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 z-[100] bg-black/90 flex items-center justify-center p-4 sm:p-8"
            onClick={() => setSelectedImage(null)}
          >
            <motion.div
              initial={{ scale: 0.85, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0.85, opacity: 0 }}
              transition={{ duration: 0.3 }}
              className="relative max-w-5xl w-full"
              onClick={(e) => e.stopPropagation()}
            >
              <button
                onClick={() => setSelectedImage(null)}
                className="absolute -top-12 right-0 w-10 h-10 flex items-center justify-center text-white/80 hover:text-white transition-colors cursor-pointer"
                aria-label="Fermer"
              >
                <i className="ri-close-line text-3xl"></i>
              </button>
              <div className="w-full h-[50vh] sm:h-[70vh] rounded-2xl overflow-hidden">
                <img
                  src={selectedImage.src}
                  alt={selectedImage.alt}
                  title={selectedImage.title}
                  className="w-full h-full object-contain bg-black"
                />
              </div>
              <div className="mt-4 text-center">
                <p className="text-white font-inter text-base font-semibold">{selectedImage.title}</p>
              </div>

              {/* Navigation */}
              <button
                onClick={(e) => {
                  e.stopPropagation();
                  const currentIdx = filteredImages.findIndex((i) => i.id === selectedImage.id);
                  const prevIdx = currentIdx > 0 ? currentIdx - 1 : filteredImages.length - 1;
                  setSelectedImage(filteredImages[prevIdx]);
                }}
                className="absolute left-2 sm:-left-4 top-1/2 -translate-y-1/2 w-11 h-11 flex items-center justify-center bg-white/10 hover:bg-white/20 backdrop-blur-sm rounded-full transition-colors cursor-pointer"
                aria-label="Photo précédente"
              >
                <i className="ri-arrow-left-s-line text-white text-2xl"></i>
              </button>
              <button
                onClick={(e) => {
                  e.stopPropagation();
                  const currentIdx = filteredImages.findIndex((i) => i.id === selectedImage.id);
                  const nextIdx = currentIdx < filteredImages.length - 1 ? currentIdx + 1 : 0;
                  setSelectedImage(filteredImages[nextIdx]);
                }}
                className="absolute right-2 sm:-right-4 top-1/2 -translate-y-1/2 w-11 h-11 flex items-center justify-center bg-white/10 hover:bg-white/20 backdrop-blur-sm rounded-full transition-colors cursor-pointer"
                aria-label="Photo suivante"
              >
                <i className="ri-arrow-right-s-line text-white text-2xl"></i>
              </button>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </section>
  );
}
